import type { TelephoneFieldValue } from "@jti/commerce-types";
import { parsePhoneNumber } from "@jti/fe-common";
import { handleAddPlusToPhone } from "@jti/rest-api";

import getDefaultCountryCode from "@checkout-v2/shared/utils/telephoneUtils/getDefaultCountryCode";

export const toTelephoneField = (
  telephoneString: string,
  isInternational: boolean,
  codes: string
): TelephoneFieldValue => {
  const defaultCode = getDefaultCountryCode(codes);
  const [code, national] = parsePhoneNumber(codes, telephoneString);

  if (isInternational) {
    return { internationalPhone: code && national ? handleAddPlusToPhone(code + national) : "" };
  }

  return {
    code: code ? { value: code, label: code } : { value: defaultCode, label: defaultCode },
    phone: national || "",
  };
};

export const toEmptyTelephoneField = (isInternational: boolean, codes: string): TelephoneFieldValue => {
  const defaultCode = getDefaultCountryCode(codes);

  if (isInternational) {
    return { internationalPhone: "" };
  }

  return {
    code: { value: defaultCode, label: defaultCode },
    phone: "",
  };
};

export const checkIsEmptyTelephoneField = (telephone: TelephoneFieldValue): boolean => {
  return !telephone.internationalPhone && !telephone.phone;
};
